import { useQuery } from "@tanstack/react-query";
import { membershipApi } from "@bw/shared/api";
import type { SubscriptionResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * The caller's subscriptions (GET /memberships/ → SubscriptionResponse[]),
 * SERVER-SCOPED to the auth user — the page never passes its own uid. Each row
 * is enriched (plan_name/facility_name/price/plan_type/visit_limit) so the list
 * renders honest labels without a second lookup. ONE cache slot (no params).
 */
export function useMyMemberships() {
  return useQuery<SubscriptionResponse[]>({
    queryKey: queryKeys.memberships.mine(),
    queryFn: () => membershipApi.listSubscriptions(),
  });
}
